import { Stack } from 'expo-router';
import { Toast, ToastProvider, ToastViewport, useTheme } from 'smoothie';

export default function SettingsLayout() {
    const theme = useTheme();

    return (
        <ToastProvider>
            <Stack
                screenOptions={{
                    headerShown: false,
                    contentStyle: {
                        backgroundColor: theme.background.get(),
                    },
                }}
            ></Stack>
            <Toast />
            <ToastViewport
                flexDirection="column"
                bottom={50}
                $sm={{ bottom: '90vh' }}
                left={0}
                right={0}
            />
        </ToastProvider>
    );
}
